import { render, staticRenderFns } from "./SpeechProblem.vue.js?vue&type=template&id=4b925408!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SpeechProblem.vue?vue&type=template&id=4b925408"
import script from "./SpeechProblem.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SpeechProblem.vue?vue&type=script&lang=js"
export * from "./SpeechProblem.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SpeechProblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports